export const FETCH_CUSTOM_PROFILE =
  'integrations/customProfile/FETCH_CUSTOM_PROFILE'
export const FETCH_CUSTOM_PROFILE_SUCCESS =
  'integrations/customProfile/FETCH_CUSTOM_PROFILE_SUCCESS'
